import { useUploadStore } from '../../../../../store/uploadStore';
import { getQueuedAndRegisteringFileCount } from '../../helpers/queues';
import { isUploadCompleted } from '../../helpers/completion';

// WARNING: Inside the open card we use this simple Upload state, but in the list
// we also mix in "overdue" and "invalid" into progress bar and badges as per the design.

export enum CalculatedUploadState {
  Completed,
  Loading,
  Interrupted,
}

export const useCalculatedUploadState = (
  isPano: boolean,
  customerId: string,
  siteId: string,
  scheduleId: string | undefined,
) => {
  const { getUpload, getRegistrationRequests } = useUploadStore();

  const upload = getUpload(isPano, customerId, siteId, scheduleId);
  const registrationRequests = getRegistrationRequests(isPano, customerId, siteId, scheduleId);

  if (
    upload &&
    !registrationRequests?.size &&
    getQueuedAndRegisteringFileCount(upload, registrationRequests) + upload.overview.photosCount.uploaded !==
      upload?.overview.photosCount.all
  ) {
    // Case where user hasn't added all non-uploaded photos after interruption
    return CalculatedUploadState.Interrupted;
  }

  if (registrationRequests?.size || upload?.queue.length) {
    return CalculatedUploadState.Loading;
  }

  if (!upload || !upload.overview.photosCount.all) {
    return null;
  }

  if (isUploadCompleted(upload)) {
    return CalculatedUploadState.Completed;
  }

  return CalculatedUploadState.Interrupted;
};
